import { BillingLocation } from 'Core/common/BillingLocation/types'
import { Http } from 'Core/utils'
import { StateProvince } from 'Core/utils/storeHelpers/types'

import { RegistrationDocument } from 'Portals/Customer/entities'

import { baseUrl, billingLocationBaseUrl } from './constants'

export const retrieveOwnershipTypes = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/ownership-types`)

export const retrieveStates = (): Promise<StateProvince[]> => Http.get('/states')

export const retrieveBankruptcyTypes = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/bankruptcy-types`)

export const saveRegistrationForm = (
	data: RegistrationDocument.Request,
	id: number
): Promise<void> => Http.put(`${baseUrl}/${id}`, data)

export const submitRegistrationForm = (
	data: RegistrationDocument.Request,
	id: number
): Promise<void> => Http.put(`${baseUrl}/${id}/submit`, data)

export const retrieveCustomerRegistrationData = (): Promise<RegistrationDocument.Basic> =>
	Http.get(`${baseUrl}/me`)

export const uploadDocument = (id: Key, data: RegistrationDocument.Document.Request) =>
	Http.post(`${baseUrl}/${id}/documents`, data, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})

export const retrieveDocuments = (id: Key): Promise<RegistrationDocument.Document.Basic[]> =>
	Http.get(`${baseUrl}/${id}/documents`)

export const retrieveDocument = ({
	id,
	documentId
}: {
	id: Key
	documentId: Key
}): Promise<RegistrationDocument.Document.Basic> =>
	Http.get(`${baseUrl}/${id}/documents/${documentId}`)

export const downloadDocument = ({ id, documentId }: { id: Key; documentId: Key }): Promise<Blob> =>
	Http.get(`${baseUrl}/${id}/documents/${documentId}/download`, {
		responseType: 'blob'
	})

export const downloadTemplateDocument = (): Promise<Blob> =>
	Http.get(`${baseUrl}/template/download`, {
		responseType: 'blob'
	})

export const retrieveCounties = (): Promise<Entity[]> => Http.get('/counties')

export const retrieveDeliveryTypes = (): Promise<Entity[]> =>
	Http.get(`${billingLocationBaseUrl}/delivery-types`)

export const retrievePurchaseOrderTypes = (): Promise<Entity[]> =>
	Http.get(`${billingLocationBaseUrl}/purchase-order-types`)

export const retrieveRebateMethods = (): Promise<Entity[]> =>
	Http.get(`${billingLocationBaseUrl}/rebate-methods`)

export const retreiveBillingLocations = ({
	registrationDocumnetId
}: {
	registrationDocumnetId: Key
}): Promise<BillingLocation.Basic[]> =>
	Http.get(`${baseUrl}/${registrationDocumnetId}/billing-location`)

export const retreiveBillingLocation = ({
	registrationDocumnetId,
	billingLocationId
}: {
	registrationDocumnetId: Key
	billingLocationId: Key
}): Promise<BillingLocation.Detailed> =>
	Http.get(`${baseUrl}/${registrationDocumnetId}/billing-location/${billingLocationId}`)

export const addBillingLocation = (
	registrationDocumnetId: Key,
	payload: BillingLocation.Request.Generic
): Promise<BillingLocation.Detailed> =>
	Http.post(`${baseUrl}/${registrationDocumnetId}/billing-location`, payload)

export const editBillingLocation = (
	registrationDocumnetId: Key,
	billingLocationId: Key,
	payload: BillingLocation.Request.Generic
): Promise<BillingLocation.Detailed> =>
	Http.put(`${baseUrl}/${registrationDocumnetId}/billing-location/${billingLocationId}`, payload)

export const deleteBillingLocation = (
	registrationDocumnetId: Key,
	billingLocationId: Key
): Promise<void> =>
	Http.delete(`${baseUrl}/${registrationDocumnetId}/billing-location/${billingLocationId}`)

export const retrieveServiceLocations = (
	id: Key
): Promise<RegistrationDocument.ServiceLocation.Basic[]> =>
	Http.get(`${baseUrl}/${id}/service-locations`)

export const deleteServiceLocations = (id: Key, serviceLocationId: Key): Promise<void> =>
	Http.delete(`${baseUrl}/${id}/service-locations/${serviceLocationId}`)

export const addServiceLocation = (
	id: Key,
	data: RegistrationDocument.ServiceLocation.Request.Generic
): Promise<RegistrationDocument.ServiceLocation.Basic> =>
	Http.post(`${baseUrl}/${id}/service-locations`, data)

export const updateServiceLocation = (
	id: Key,
	serviceLocationId: Key,
	data: RegistrationDocument.ServiceLocation.Request.Generic
): Promise<RegistrationDocument.ServiceLocation.Basic> =>
	Http.put(`${baseUrl}/${id}/service-locations/${serviceLocationId}`, data)
